import {imageWrapperIconImgToVideo} from "../components/imageWrapperIconImgToVideo";

function imageWrapper(element) {
    $(document).ready(function () {
        setImageWrapperActions();
    });

    function setImageWrapperActions() {
        $('.image-wrapper').each(function (index, element) {
            initImageWrapperActions(element);
        });
    }

    function initImageWrapperActions(element) {
        imageWrapperIconImgToVideo(element);
    }

    /**
     * Message returned
     */
    document.addEventListener('growtypeChatContentRendered', function (event) {
        $(event['detail']['contentWrapper']).find('.image-wrapper').each(function (index, element) {
            initImageWrapperActions(element);
        });
    });

    document.addEventListener('growtypeChatMessageReturnFinished', function (event) {
        $(event['detail']['userMessageTemplate']).each(function (index, element) {
            $(element).find('.image-wrapper').each(function (index, element) {
                initImageWrapperActions(element);
            });
        });
    });
}

export {imageWrapper};
